export const en = {
    'save': 'Save',
    'cancel': 'Close',
    'default-connection-type': 'Connection type by default',
};
